import moment from "moment";
import {
  getAuth,
  onAuthStateChanged,
  signOut,
  fetchSignInMethodsForEmail,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { TYPES } from "./bailiff_auth.type";
import { SOURCE } from "config/config";
import { getApiFunctions } from "../api";
import { getApp } from "firebase/app";
import { convertVnTime } from "util/time.function";

const app = getApp();
const auth = getAuth(app);

// -------------------------- Snapshot --------------------------
const authSub = [];
export const snapBailiffAuth = () => (dispatch) => {
  console.log({ userOutside: auth?.currentUser });
  const unSub = onAuthStateChanged(auth, async (user) => {
    console.log("change auth base");
    console.log({ userInside: user });
    const uid = user?.uid;
    console.log({ uid });
    const isLogged = uid ? true : false;
    const reloadUserInfo = user?.reloadUserInfo;
    const permissions = reloadUserInfo?.customAttributes;
    const lastRefreshAt = reloadUserInfo?.lastRefreshAt;
    const lastRefresh = convertVnTime(lastRefreshAt);
    const bailiff = { permissions, lastRefresh };
    console.log({ userb: bailiff });

    const time = moment().toISOString();
    const current = `auth-base:${JSON.stringify(isLogged)}-(${time})`;
    console.log(current);
    firebasePermissionSuccess(dispatch, permissions);
    firebaseAuthSuccess(dispatch, isLogged);
    firebaseUidSuccess(dispatch, uid);
  });
  authSub.push(unSub);
};

export const unSnapBailiffAuth = () => (dispatch) => {
  authSub.forEach((subscriber) => {
    subscriber();
  });
  authSub.length = 0;
};

export const logOut = () => (dispatch) => {
  signOut(auth);
};

export const getCustomClaim = () => {
  auth.currentUser
    .getIdTokenResult()
    .then((idTokenResult) => {
      const claims = idTokenResult?.claims;
      console.log({ idTokenResult, claims });
    })
    .catch((error) => {
      console.log(error);
    });
};

export const checkEmail =
  ({ register }, callback) =>
  (dispatch) => {
    const email = register.email;
    console.log({ email });
    return fetchSignInMethodsForEmail(auth, email)
      .then((response) => {
        console.log({ response });
        if (response.length === 0) {
          if (callback) {
            callback({
              status: 200,
            });
          }
          firebaseRegisterSuccess(dispatch, register);
        } else {
          callback({
            status: 500,
            data: "auth/email-already-in-use",
          });
        }
      })
      .catch((error) => console.log({ error }));
  };

export const registerEmailPassword =
  ({ register }, callback) =>
  (dispatch) => {
    const email = register.email;
    const password = register.password;
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        if (callback) {
          callback({
            status: 200,
            data: user,
          });
        }
      })
      .catch((error) => {
        console.log({ error });
        if (callback) {
          callback({
            status: 500,
            data: error.code,
          });
        }
      });
  };

// ================ CLOUD FUNCTIONS ==================== //

export const sendEmail =
  ({ email }, callback) =>
  (dispatch) => {
    const apiEmailVerify = getApiFunctions().email.emailSendCode;
    apiEmailVerify({ email, source: SOURCE })
      .then((response) => {
        console.log({ response });
        const data = response.data;
        const lastSent = moment().toDate();
        firebaseGetLastMailSuccess(dispatch, lastSent);
        if (callback) {
          callback(data);
        }
      })
      .catch((err) => {
        console.log({ err });
        callback({ status: 500, data: err?.data || "Invalid Error" });
      });
  };

export const verifyEmail =
  ({ email, pincode }, callback) =>
  (dispatch) => {
    const apiEmailVerify = getApiFunctions().email.emailCheckCode;
    apiEmailVerify({ email, pincode, source: SOURCE })
      .then((response) => {
        const data = response.data;
        if (callback) {
          callback(data);
        }
      })
      .catch((err) => console.log({ err }));
  };

export const setStepRegister = (step) => (dispatch) => {
  setRegisterStepSuccess(dispatch, step);
};

// -------------------------- Dispatch --------------------------
const firebaseAuthSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_STATUS,
    payload: data,
  });
};

const firebaseUidSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_UID,
    payload: data,
  });
};

const firebasePermissionSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_PERMISSIONS,
    payload: data,
  });
};

const firebaseRegisterSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_REGISTER_SUCCESS,
    payload: data,
  });
};

const setRegisterStepSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_REGISTER_STEP,
    payload: data,
  });
};

const firebaseGetLastMailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_REGISTER_LASTMAIL,
    payload: data,
  });
};
